import React from "react";
import { googleAds } from "appConfig";
import GoogleAd from "../../../components/GoogleAd";
import styles from "./stickySkyBanners.scss";

interface StickySkyBannersProps {
  forbiddAds?: boolean;
}

// Side skyscraper billboards (V2OGLASI-2631). Fixed to the left and right of
// the centered page content, visible only on screens wide enough to hold a
// 300px banner on each side of the 1360px max-width layout. GoogleAd handles
// its own hasIndexPremium / profileLoading opt-out.
const StickySkyBanners: React.FC<StickySkyBannersProps> = ({ forbiddAds }) => {
  if (forbiddAds) {
    return null;
  }

  return (
    <React.Fragment>
      <GoogleAd
        className={`${styles.skyBanner} ${styles.skyLeft}`}
        config={{ ...googleAds.ODO_sky_left, id: "googleAds.ODO_sky_left" }}
        noTopMargin
        noBottomMargin
      />
      <GoogleAd
        className={`${styles.skyBanner} ${styles.skyRight}`}
        config={{ ...googleAds.ODO_sky_right, id: "googleAds.ODO_sky_right" }}
        noTopMargin
        noBottomMargin
      />
    </React.Fragment>
  );
};

export default StickySkyBanners;



// WEBPACK FOOTER //
// ./src/containers/App/StickySkyBanners/StickySkyBanners.tsx